import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/tireBrands/actionTypes';

export default createSearchReducers(types.FETCH_TIRE_BRAND_REQUEST);
